export const localStorageTypes = {
  user: 'user',
  authTypes: 'authTypes',
  token: 'token',
  redirectUrl: 'redirectUrl',
  accountTypes: 'accountTypes',
  firstName: 'firstName',
  tenant: 'tenant',
  usedOperations: 'usedOperations',
  disallowedOperations: 'disallowedOperations',
  disableAllowance: 'disableAllowance',
  userDisplayName: 'userDisplayName',
  allowedOperationsNew: 'allowedOperationsNew',
  userGroupIds: 'userGroupIds',
  notificationsDenied: 'notificationsDenied',
  emptyChatsMode: 'emptyChatsMode',
  fakeAIMessage: 'fakeAIMessage',
  localeID: 'localeID',
  extensionId: 'extensionId',
  debugSocket: 'debugSocket',
  debugSocketOutgoing: 'debugSocketOutgoing',
  disableTranslations: 'disableTranslations',
  disableTracing: 'disableTracing',
  showTranslated: 'showTranslated',
  locale: 'locale',
  disableSLA: 'disableSLA',
  hideInactivePipelinesFlag: 'hideInactivePipelinesFlag',
  ll: 'll',
  FormCandidate: 'FormCandidate',
  pageSize: 'pageSize',
  FormJobRequest: 'FormJobRequest',
  showEmptyLegacy: 'showEmptyLegacy',
  debugLog: 'debugLog',
  processedLiterals: 'processedLiterals',
  useCustomForm: 'useCustomForm',
} as const;
